import {Buffer} from 'buffer';
import SystemRegistry from '../systemRegistry';

export class NoMicropython extends Error {

}

export default class MicroPythonBoard {
    async list_authorized_ports() {
        return await navigator.serial.getPorts()
    }


    requestPort(deviceFilter) {
        return navigator.serial.requestPort({ filters: deviceFilter })
            .then((port) => {
                console.log("Connection successfull!")
                return port
            })    
        .catch((e) => {
                console.log(e)
                console.log('No device selected')
            });

    }
    async open(port, options) {
        if (!port) {
            return Promise.reject(
                new Error(`No device specified`)
            )
        }

        // TODO: check if device is still connected?
        console.log(this.serial)
        if (this.serial) {
            await this.serial.close()

        }

        this.serial = port
        let x = await this.serial.open(options)
        console.log("Port opened")
        return x
    }

    close() {
        if (this.serial) {
            return this.serial.close()
        } else {
            return Promise.resolve()
        }
    }

    async read_until(ending, data_consumer, timeoutFlag) {
        let buffer = ''
        const reader = this.serial.readable.getReader()
        const decoder = new TextDecoder()
        let canceled = false
        let timeout = 0
        if(timeoutFlag) {
            timeout = setTimeout(()=> {
                canceled = true
                reader.releaseLock();

            }, 5000)
        }
        try {
            console.log("Reading until " + ending)
            while (true) {
                const { value, done } = await reader.read();
                if(canceled) {
                    throw Error("Timeout reached")
                }
                if (done) {
                    throw Error("Read Error! Stream closed!")
                }
                // if defined value was returned
                if (value) {
                    let newText = decoder.decode(value)
                    buffer += newText
                    SystemRegistry.gI().console.addConsoleMessage(newText, SystemRegistry.gI().console.INFO)

                    if (data_consumer) {
                        data_consumer(decoder.decode(value))
                    }
                }
                // if ending is reached stop reading
                if (buffer.indexOf(ending) !== -1) {
                    break
                }
            }
            console.log("Read until " + ending + " finished")

        } catch (error) {
            console.log(error)
            clearTimeout(timeout)
            reader.releaseLock();
            throw Error("Read Error!")
        }
        clearTimeout(timeout)
        reader.releaseLock();
        return buffer
        
    }

    async write(data) {
        const writer = this.serial.writable.getWriter()
        await writer.write(Buffer.from(data))
        writer.releaseLock()
    }

    async write_and_read_until(cmd, expect, data_consumer, timeout) {
        //this.serial.readable.pause()
        const encoder = new TextEncoder();
        const writer = this.serial.writable.getWriter()
        await writer.write(encoder.encode(cmd))

        /*for (let i = 0; i < cmd.length; i += chunkSize) {
            const s = cmd.slice(i, i + chunkSize)
            await writer.write(encoder.encode(s))
            await sleep(10)
        }*/
        writer.releaseLock()

        let o
        if (expect) {
            
            o = await this.read_until(expect, data_consumer, timeout)
        }
        await sleep(10)
        //await this.serial.readable.resume()
        return o
    }

    async get_prompt() {
        await sleep(150)
        await this.stop()
        await sleep(150)
        const out = await this.write_and_read_until(`\r\x03\x02`, '\r\n>>>')
        return Promise.resolve(out)
    }
    async enter_raw_repl() {
        const out = await this.write_and_read_until(`\x01`, `raw REPL; CTRL-B to exit\r\n>`, undefined, true)
        return Promise.resolve(out)
    }

    async exit_raw_repl() {
        const out = await this.write_and_read_until(`\x02`, '\r\n>>>')
        return Promise.resolve(out)
    }

    async exec_raw(cmd, data_consumer) {
        await this.write_and_read_until(cmd)
        const out = await this.write_and_read_until('\x04', '\x04>', data_consumer)
        return Promise.resolve(out)
    }

    async execfile(fileString, data_consumer) {
        data_consumer = data_consumer || function () { }
        await this.enter_raw_repl()
        const output = await this.exec_raw(fileString, data_consumer)
        await this.exit_raw_repl()
        return Promise.resolve(output)
    }
    async getFirmwareVersion() {
        let command = `try:\n`
        command += `  from arduino_alvik import ArduinoAlvik\n`
        command += `  alvik = ArduinoAlvik()\n`
        command += `  alvik.begin()\n`
        command += `  print(str("[") + str(alvik.get_fw_version()) + str("]"))\n`
        command += `  print(str("[") + str(alvik.get_lib_version()) + str("]"))\n`
        command += `except OSError:\n`
        command += `  print("[0.0.0]")\n`

        await sleep(150)
        await this.stop()
        await sleep(150)
        try {
            console.log("Opening raw repl")
            await this.enter_raw_repl()
            console.log("Raw repl opened")
        } catch (e) {
            console.log("Can't open raw repl")
            throw new NoMicropython("Can't open raw repl");

        }
        let output = await this.exec_raw(command)
        await this.exit_raw_repl()
        console.log("Raw repl exited")

        output = Array.from(output.matchAll(/\[(.*)\]/g))
        return {"firmwareVersion": output[0][1], "libVersion": output[1][1]}
    }

    async run(code, data_consumer) {
        data_consumer = data_consumer || function () { }
        return new Promise(async (resolve, reject) => {
            if (this.reject_run) {
                this.reject_run(new Error('re-run'))
                this.reject_run = null
            }
            this.reject_run = reject
            try {
                await this.enter_raw_repl()
                const output = await this.exec_raw(code || '#', data_consumer)
                await this.exit_raw_repl()
                return resolve(output)
            } catch (e) {
                reject(e)
                this.reject_run = null
            }
        })

    }

    async eval(k) {
        await this.write(k.toString())
        return Promise.resolve()
    }

    async stop() {
        if (this.reject_run) {
            this.reject_run(new Error('pre stop'))
            this.reject_run = null
        }
        // Dismiss any data with ctrl-C
        await this.write(`\x03`)
        return Promise.resolve()
    }

    async reset() {
        if (this.reject_run) {
            this.reject_run(new Error('pre reset'))
            this.reject_run = null
        }
        // Dismiss any data with ctrl-C
        await this.write(`\x03`)
        // Soft reboot
        await this.write(`\x04`)
        return Promise.resolve()
    }

    async fs_exists(filePath) {
        filePath = filePath || ''
        let command = `try:\n`
        command += `  f = open("${filePath}", "r")\n`
        command += `  print(1)\n`
        command += `except OSError:\n`
        command += `  print(0)\n`
        await this.enter_raw_repl()
        let output = await this.exec_raw(command)
        await this.exit_raw_repl()
        console.log(typeof(output))
        for (let i = 0; i < output.length; i++) {
            const element = output[i];
            console.log(i + ": " + element)
            
        }
        console.log(output[2])
        const exists = output[2] === '1'
        return exists
    }

    async fs_ls(folderPath) {
        folderPath = folderPath || ''
        let command = `import uos\n`
        command += `try:\n`
        command += `  print(uos.listdir("${folderPath}"))\n`
        command += `except OSError:\n`
        command += `  print([])\n`
        await this.enter_raw_repl()
        let output = await this.exec_raw(command)

        await this.exit_raw_repl()
        output = extract(output)
        // Convert text output to js array
        output = output.replace(/'/g, '"')
        const files = JSON.parse(output)
        return files
    }

    async fs_ils(folderPath) {
        folderPath = folderPath || ''
        folderPath = folderPath || ''
        let command = `import uos\n`
        command += `try:\n`
        command += `  l=[]\n`
        command += `  for file in uos.ilistdir("${folderPath}"):\n`
        command += `    l.append(list(file))\n`
        command += `  print(l)\n`
        command += `except OSError:\n`
        command += `  print([])\n`
        await this.enter_raw_repl()
        let output = await this.exec_raw(command)
        await this.exit_raw_repl()
        // Convert text output to js array
        output = extract(output)
        output = output.replace(/'/g, '"')
        output = output.split('OK')
        let files = JSON.parse(output)
        return Promise.resolve(files)
    }

    async fs_cat(filePath) {
        if (filePath) {
            await this.enter_raw_repl()
            let output = await this.exec_raw(
                `with open('${filePath}','r') as f:\n while 1:\n  b=f.read(256)\n  if not b:break\n  print(b,end='')`
            )
            await this.exit_raw_repl()
            output = extract(output)
            return Promise.resolve(fixLineBreak(output))
        }
        return Promise.reject(new Error(`Path to file was not specified`))
    }

    async fs_save(content, dest, data_consumer) {
        if(this.serial.readable.locked) {
            this.serial.getReader().cancel()
        }
        data_consumer = data_consumer || function () { }
        if (content && dest) {
            const contentBuffer = Buffer.from(content, 'utf-8')
            let out = ''
            out += await this.enter_raw_repl()
            out += await this.exec_raw(`f=open('${dest}','wb')\nw=f.write`)
            const chunkSize = 48
            for (let i = 0; i < contentBuffer.length; i += chunkSize) {
                let slice = Uint8Array.from(contentBuffer.subarray(i, i + chunkSize))
                let line = `w(bytes([${slice}]))`
                out += await this.exec_raw(line)
                data_consumer(parseInt((i / contentBuffer.length) * 100) + '%')
            }
            out += await this.exec_raw(`f.close()`)
            out += await this.exit_raw_repl()
            return Promise.resolve(out)
        } else {
            return Promise.reject(new Error(`Must specify content and destination path`))
        }
    }

    async fs_mkdir(filePath) {
        if (filePath) {
            await this.enter_raw_repl()
            const output = await this.exec_raw(
                `import uos\nuos.mkdir('${filePath}')`
            )
            await this.exit_raw_repl()
            return Promise.resolve(output)
        }
        return Promise.reject()
    }

    async fs_rmdir(filePath) {
        if (filePath) {
            let command = `import uos\n`
            command += `try:\n`
            command += `  uos.rmdir("${filePath}")\n`
            command += `except OSError:\n`
            command += `  print(0)\n`
            await this.enter_raw_repl()
            const output = await this.exec_raw(command)
            await this.exit_raw_repl()
            return Promise.resolve(output)
        }
        return Promise.reject()
    }

    async fs_rm(filePath) {
        if (filePath) {
            let command = `import uos\n`
            command += `try:\n`
            command += `  uos.remove("${filePath}")\n`
            command += `except OSError:\n`
            command += `  print(0)\n`
            await this.enter_raw_repl()
            await this.exec_raw(command)
            return this.exit_raw_repl()
        }
        return Promise.reject()
    }

    async fs_rename(oldFilePath, newFilePath) {
        if (oldFilePath && newFilePath) {
            await this.enter_raw_repl()
            await this.exec_raw(
                `import uos\nuos.rename('${oldFilePath}', '${newFilePath}')`
            )
            return this.exit_raw_repl()
        }
        return Promise.reject()
    }

}

function sleep(millis) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve()
        }, millis)
    })
}

function fixLineBreak(str) {
    // All line breaks must be converted to \n
    // https://stackoverflow.com/questions/4025760/python-file-write-creating-extra-carriage-return
    return str.replace(/\r\n/g, '\n')
}

function extract(out) {
    /*
     * Message ($msg) will come out following this template:
     * "OK${msg}\x04${err}\x04>"
     * TODO: consider error handling
     */
    return out.slice(2, -3)
}